<ul class="nav nav-secondary account-details-nav">
  <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <!--Account Icon Switch-->
    <ng-container *ngIf="googleIcons; else basicIconAccount">
      <div class="icon material-icons">person</div>
    </ng-container>
    <ng-template #basicIconAccount>
      <div class="icon icon-user"></div>
    </ng-template>
    <!---->
    <label>{{ 'account.nav.profile' | translate }}</label>
  </a>
  <a class="nav-item" [routerLink]="['/activity']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <!--Activity Icon Switch-->
    <ng-container *ngIf="googleIcons; else basicIconActivity">
      <div class="icon material-icons">history</div>
    </ng-container>
    <ng-template #basicIconActivity>
      <div class="icon svg activity" [inlineSVG]="'assets/images/icons/nodes.svg'"></div>
    </ng-template>
    <!---->
    <label>{{ 'account.nav.activity' | translate }}</label>
  </a>
  <a class="nav-item" [routerLink]="['/partners']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <!--Partners Icon Switch-->
    <ng-container *ngIf="googleIcons; else basicIconPartner">
      <div class="icon material-icons">people</div>
    </ng-container>
    <ng-template #basicIconPartner>
      <div class="icon icon-users"></div>
    </ng-template>
    <!---->
    <label>{{ 'account.nav.partners' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/pointsmanagement']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <!--Points Management Icon Switch-->
    <ng-container *ngIf="googleIcons; else basicIconPoints">
      <div class="icon material-icons">emoji_events</div>
    </ng-container>
    <ng-template #basicIconPoints>
      <div class="icon icon-trophy-1"></div>
    </ng-template>
    <!---->
    <label>{{ 'account.nav.points.management' | translate }}</label>
  </a>
  <a class="nav-item" [routerLink]="['/subscriptions']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <!--Subscriptions Icon Switch-->
    <ng-container *ngIf="googleIcons; else basicIconSubscription">
      <div class="icon material-icons">auto_awesome</div>
    </ng-container>
    <ng-template #basicIconSubscription>
      <div class="icon icon-star-circle"></div>
    </ng-template>
    <!---->
    <label>{{ 'account.nav.subscriptions' | translate }}</label>
  </a>
  <a
    class="nav-item"
    [routerLink]="['/notificationmanagement']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <!--Notification Manager Icon Switch-->
    <ng-container *ngIf="googleIcons; else basicIcon">
      <div class="icon material-icons">notifications</div>
    </ng-container>
    <ng-template #basicIcon>
      <div class="icon icon-notification"></div>
    </ng-template>
    <!---->
    <label>{{ 'account.nav.management' | translate }}</label>
  </a>
</ul>
